import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import ShippingServiceDropdown from './shipping-service-dropdown';
import { getGroupedShippingServicesForType } from '../../store/shipping-service/group-selector';
import style from './style.module.less';
import { CarrierSharingService } from '../../store/carrier-sharing/carrier-sharing-service';
import Global from '../../store/global-selectors';
import { emptyArray } from 'ui-components/default-props/empty';
import { useIsVendorOr3PL } from '../../hooks/use-is-vendor-or-3pl';

import { useSelectedOrdersView } from '../../pages/orders-page/orders-left-nav/orders-left-nav-context';

const GroupedServiceDropdown = ({ selectedCarrierId = '', selectedServiceId = '', onChange, selectedLabelProviderId = '' }) => {
  const isVendorOr3PL = useIsVendorOr3PL();
  const groupByProps = { shouldShowPrimaryOnly: true };
  let groupedShippingServices = useSelector((state) => getGroupedShippingServicesForType('Provider', state, groupByProps));
  const { storeGuid } = useSelectedOrdersView();
  const sharedByPartnerServices = useSelector(Global.selectSellerPartnerSharedServices);

  if (isVendorOr3PL) {
    groupedShippingServices = CarrierSharingService.combineSharedServices(groupedShippingServices, storeGuid, sharedByPartnerServices);
    groupedShippingServices = groupedShippingServices.map((element) => {
      if (element.items) {
        const updatedElement = {
          ...element,
          services: element.items,
          serviceGroupId: element.groupId,
          serviceGroupType: 'seller-label-provider',
        };
        if (updatedElement.services !== emptyArray) {
          updatedElement.serviceGroupTypeObject = {
            labelProviderId: updatedElement.services[0].labelProviderId,
          };
        }
        return updatedElement;
      }
      return element;
    });
  }

  return (
    <div className={style['grouped-service-dropdown']}>
      <ShippingServiceDropdown
        onChange={onChange}
        selectedCarrierId={selectedCarrierId}
        selectedLabelProviderId={selectedLabelProviderId}
        selectedServiceId={selectedServiceId}
        shippingServiceGroups={groupedShippingServices}
      />
    </div>
  );
};

GroupedServiceDropdown.propTypes = {
  onChange: PropTypes.func.isRequired,
  selectedCarrierId: PropTypes.string,
  selectedServiceId: PropTypes.string,
  selectedLabelProviderId: PropTypes.string,
};

export default GroupedServiceDropdown;
